export const highchartsTooltipCfg = (tooltipCfg: any) => {
  const headerLineHeight = Number.parseFloat(String(tooltipCfg.headerFontSize).replace('px', '')) * 1.25;
  const contentLineHeight = Number.parseFloat(String(tooltipCfg.contentFontSize).replace('px', '')) * 1.25;
  return {
    hideDelay: tooltipCfg.hideDelay,
    split: false,
    shared: true,
    valueDecimals: 2,
    xDateFormat: '%A, %b %d, %Y',
    borderColor: tooltipCfg.borderColor,
    borderWidth: tooltipCfg.borderWidth,
    borderRadius: Number(tooltipCfg.borderRadius.replace('px', '')),
    backgroundColor: tooltipCfg.backgroundColor,
    headerFormat: `<div style='letter-spacing:${tooltipCfg.letterSpacing - 0.75}px;font-weight:${
      tooltipCfg.headerFontWeight
    };font-size:${tooltipCfg.headerFontSize};line-height:${headerLineHeight}px;margin-bottom:${
      tooltipCfg.headerMarginBottom
    };'>{point.key}</div>`,
    pointFormat: `<div style='letter-spacing:${tooltipCfg.letterSpacing - 0.75}px;font-weight:${
      tooltipCfg.contentFontWeight
    };font-size:${tooltipCfg.contentFontSize};line-height:${contentLineHeight}px;'><span style="color:{point.color}">\u25CF</span> {series.name}: {point.y}</div>`,
    padding: Number(tooltipCfg.padding.replace('px', '')),
    style: {
      'stroke-dasharray':
        tooltipCfg.borderStyle === 'solid' ? 'none' : tooltipCfg.borderStyle === 'dotted' ? '2,2' : '5,5',
      color: tooltipCfg.color,
      opacity: tooltipCfg.opacity,
    },
    shadow: false,
    useHTML: true,
    zIndex: 5,
  };
};
